<template>
  <div class="upload">

    <kendo-upload ref="upload"
                  name="files"
                  :multiple="true"
                  :show-file-list="false"
                  :async-auto-upload="false"
                  :localization-select="'파일 선택'"
                  @select="onSelectFile"
                  :validation-allowed-extensions='[".jpeg", ".jpg", ".png"]'>
    </kendo-upload>

    <div class="k-upload" v-show="file !== ''">
      <ul class="k-upload-files k-reset" style="width:100%">
        <li v-bind:id="index" class="k-file" v-for="(fileItem,index) in file">
          <span class="k-progress" style="width: 100%;"></span>
          <span :id="'previewImage_'+fileItem.uid"></span>
          <span v-if="fileItem.url !== undefined"><img :src="fileItem.url"  style='width:40px;height: 40px;'></span>
          <span class="k-file-name-size-wrapper">
          <span class="k-file-name">{{fileItem.name}}</span>
          <span class="k-file-size">{{Math.round(0.001*parseInt(fileItem.size))}} KB</span></span>
          <strong class="k-upload-status">
            <button type="button" class="k-button k-upload-action" aria-label="Remove" @click="removeExistFiles(index)">
            <span class="k-icon k-i-close k-i-x" title="Remove"></span></button>
          </strong>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    file: {
      default: []
    }
  },
  mounted: function () {

  },
  data: function () {
    return {
      vvsrc: ''
    }
  },
  methods: {
    onSelectFile: function (e) {
      const files = e.files

      // 확장자 체크
      let fileSpliceIndex = -1

      files.forEach(file => {
        // 불허 확장자 array
        const notAllowedExtArray = ['.gif']
        if (notAllowedExtArray.includes(file.extension)) {
          // 불허 확장자 파일 index
          fileSpliceIndex = files.indexOf(file)

          kendo.alert(file.extension + '파일은 선택하실 수 없습니다.')
          e.preventDefault()
        }
      })

      if (fileSpliceIndex < 0) {
        const fileInfo = e.files[0]
        this.file = fileInfo

        setTimeout(function () {
          const raw = fileInfo.rawFile
          const reader = new FileReader()
          const name = fileInfo.name
          const w = this
          if (raw) {
            reader.onloadend = function () {
              w.document.getElementById('previewImage_' + fileInfo.uid).innerHTML = '<img alt=' + name + ' src=' + this.result + " style='width:40px;height: 40px;'>"
            }

            reader.readAsDataURL(raw)
          }
        })

        this.$emit('child', files)
      }
    },
    removeExistFiles: function (idx) {
      document.getElementById(idx).style.display = 'none'
      const id = this.file.findIndex(function (item) {
        return parseInt(item.seq) === parseInt(idx)
      })

      if (id > -1) {
        this.file.splice(id, 1)
      }
    }
  }
}
</script>
<style>
  .upload span.k-file-extension {
    font-size: 10px !important;
  }
</style>
